<template>
  <v-img
    class="my-10"
    :height="height"
    :width="width"
    contain
    :lazy-src="`${path}${value}${typeFile}`"
    :src="`${path}${value}${typeFile}`"
  ></v-img>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default() {
        return "";
      },
    },
    height: {
      type: Number,
      default() {
        return 100;
      },
    },
    width: {
      type: Number,
      default() {
        return 2100;
      },
    },
  },
  data() {
    return {
      path: `${process.env.VUE_APP_API_URL}/`,
      typeFile: ".svg",
    };
  },
};
</script>
